import { Row, Typography } from "antd";
import { QueryClientProvider } from "@tanstack/react-query";
import type { TFunction } from "i18next";
import { useTranslation } from "react-i18next";

import { ConnectionsOverview } from "./components/ConnectionsOverview";
import { queryClient } from "./client";
import { IUser } from "@/v1/types";

const getTexts = (t: TFunction) => ({
  title: t("title"),
});

export const AccountingConnections = ({
  user,
}: {
  user: IUser | undefined;
}) => {
  const { t } = useTranslation("Documents");
  const texts = getTexts(t);

  return (
    <QueryClientProvider client={queryClient}>
      <div className="mt-4">
        <Row align="middle" justify="space-between">
          <Typography.Title level={3}> {texts.title} </Typography.Title>
        </Row>
        <div className="mt-2">
          {user && <ConnectionsOverview customerId={user.publicId} />}
        </div>
      </div>
    </QueryClientProvider>
  );
};
